import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Forgot from "../../Modals/Forgote/Forgot";
import Login from "../../Modals/login";
import SignUp from "../../Modals/SignUp/SignUp";
import styles from "./LoginSignUp.module.scss";

export default function LoginSignUp() {
  const history = useHistory();
  const [isOpenSignup, setIsOpenSignup] = useState(false);
  const [isOpenLogin, setIsOpenLogin] = useState(false);
  const [isOpenForgot, setIsOpenForgot] = useState(false);

  const toggleLogin = () => {
    setIsOpenLogin(!isOpenLogin);
  };
  const toggleForgot = () => {
    setIsOpenForgot(!isOpenForgot);
  };
  const toggleSignup = () => {
    setIsOpenSignup(!isOpenSignup);
  };
  const handleForgot = () => {
    setIsOpenLogin(false);
    setIsOpenSignup(false);
    setIsOpenForgot(true);
  };
  const handleSignUp = () => {
    setIsOpenLogin(false);
    setIsOpenSignup(true);
    setIsOpenForgot(false);
  };
  const handleLogin = () => {
    setIsOpenLogin(true);
    setIsOpenSignup(false);
    setIsOpenForgot(false);
  };
  return (
    <>
      <div className={styles.rightWrapper}>
        <div className={styles.buttonWrapper} onClick={toggleLogin}>
          <button className={styles.button} >
            <span className={styles.text}>Login</span>
          </button>
        </div>
        <div className={styles.buttonWrapper} onClick={toggleSignup}>
          <button className={styles.button}>
            <span className={styles.text}>Sign Up</span>
          </button>
        </div>
      </div>
      <Login
        isOpen={isOpenLogin}
        toggle={toggleLogin}
        handleForgot={handleForgot}
        handleSignUp={handleSignUp}
      />
      <SignUp
        isOpen={isOpenSignup}
        toggle={toggleSignup}
        handleLogIn={handleLogin}
      />
      <Forgot isOpen={isOpenForgot} toggle={toggleForgot} />
    </>
  );
}
